var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditBtn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 18,
    viewBox: "0 0 12 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.14309 13.8975L4.98633 2.63201L3.78279 2.26953L0.000234604 13.3633L0.126657 13.5875L1.14309 13.8975Z",
    fill: "#393939"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.44401 15.6203L11.2266 4.52654L10.023 4.16406L6.18484 15.4296L7.20634 15.7348L7.44401 15.6203Z",
    fill: "#393939"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2268 4.52697L10.8398 5.66211L3.39715 3.40505L3.78413 2.26991L11.2268 4.52697Z",
    fill: "#393939"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0022 2.2594L11.6152 3.39453L4.17254 1.13747L4.55952 0.00233464L12.0022 2.2594Z",
    fill: "#393939"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.96901 14.0895L7.58203 15.2246L0.139342 12.9675L0.526321 11.8324L7.96901 14.0895Z",
    fill: "#393939"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3418 16.1527L0.566829 14.4023L1.38099 15.9L4.75393 16.9206L6.3418 16.1527Z",
    fill: "#393939"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.65234 17.4543L3.07586 16.3955L2.32744 15.0171L1.1239 12.8184L0.00127029 13.3621L0.127692 13.5862L0.567642 14.4018L1.3818 15.8994L1.46777 16.0521L1.92289 16.8867L1.94817 16.9392L2.52971 17.998L3.65234 17.4543Z",
    fill: "#393939"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.44336 15.6202L6.86687 14.5566L4.64184 15.6393L3.07421 16.3977L3.04892 16.4072L1.94652 16.9414L2.52806 18.0002L7.44336 15.6202Z",
    fill: "#393939"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBtn);
export default __webpack_public_path__ + "static/media/edit-btn.8be3e86132ea4a007474f3ccc0ed0cb7.svg";
export { ForwardRef as ReactComponent };